"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.map.js");
var _log = require("@/utils/log");
var _cookie = require("@/utils/cookie");
var _organizations = require("@/api/organizations");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _subscriptions = require("@/api/subscriptions");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionCreate',
  data() {
    return {
      Constants,
      loggedInUserTenants: [],
      fullscreenloading: false,
      dialogLoopVisible: false,
      loopTableLoading: false,
      dialogCoachVisible: false,
      coachTableLoading: false,
      organizations: [],
      loopList: [],
      loopTotal: 0,
      loopQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      coachList: [],
      coachTotal: 0,
      coachQuery: {
        page: 1,
        limit: 5,
        q: undefined
      },
      form: {
        id: '',
        tenant: Constants.TENANT_LIFEHIKES,
        organization: '',
        title: '',
        startDate: '',
        endDate: '',
        status: 'Published',
        loops: [],
        coaches: [],
        sessionsPerUser: 1,
        overallQuota: 0,
        expiryDate: '',
        performance: {
          checkinPassingRate: 80,
          minimumStepCount: 0
        }
      }
    };
  },
  created() {
    this.getOrganizationsList();
    this.getLoggedInUserTenants();
    this.loadSubscription();
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    getLoggedInUserTenants() {
      if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
        this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
      } else {
        this.loggedInUserTenants = [Constants.TENANT_LIFEHIKES, Constants.TENANT_LIFEHIKES_FOUNDATION];
      }
    },
    getOrganizationsList() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      (0, _organizations.getAllOrganizations)(token).then(response => {
        if (response.data && response.data.rows) {
          this.organizations = response.data.rows.map(org => ({
            id: org.id,
            name: org.name
          }));
        }
      }).catch(error => {
        (0, _log.showDebugLog)('getAllOrganizations-api-error', error);
      });
    },
    loadSubscription() {
      if (this.loggedInUserTenants && this.loggedInUserTenants.length > 0) {
        this.form.tenant = this.loggedInUserTenants[0];
      } else {
        this.form.tenant = Constants.TENANT_LIFEHIKES;
      }
      this.form.expiryDate = '';
    },
    doSave() {
      if (!this.form.title) {
        (0, _log.displayPopupMessage)('Subscription Title is required.', 'error');
        return;
      }
      if (!this.form.startDate) {
        (0, _log.displayPopupMessage)('Start date is required.', 'error');
        return;
      }
      if (!this.form.endDate) {
        (0, _log.displayPopupMessage)('End date is required.', 'error');
        return;
      }
      if (new Date(this.form.endDate) < new Date(this.form.startDate)) {
        (0, _log.displayPopupMessage)('End date cannot be earlier than start date.', 'error');
        return;
      }

      // Check that all coaches have a Calendly link
      for (const coach of this.form.coaches) {
        if (!coach.calendlyLink || !coach.calendlyLink.trim()) {
          (0, _log.displayPopupMessage)(`Calendly Event Type Link is required for coach ${coach.givenName} ${coach.familyName}.`, 'error');
          return;
        }
      }
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      if (token) {
        this.fullscreenloading = true;
        const org = this.organizations.find(o => o.name === this.form.organization);
        const organizationId = org ? org.id : '';
        const payload = {
          metadata: {
            tenant: this.form.tenant
          },
          organizationId: organizationId,
          title: this.form.title,
          startDate: this.form.startDate ? new Date(this.form.startDate + 'T00:00:00.000Z').toISOString() : null,
          endDate: this.form.endDate ? new Date(this.form.endDate + 'T23:59:59.000Z').toISOString() : null,
          relatedPrograms: this.form.loops.map(loop => ({
            programType: 'Loop',
            programId: loop.id
          })),
          userPerformance: {
            checkinPassingRate: this.form.performance && this.form.performance.checkinPassingRate !== null && this.form.performance.checkinPassingRate !== undefined ? Number((Number(this.form.performance.checkinPassingRate) / 100).toFixed(4)) : 0.8,
            minimumStepCount: this.form.performance && this.form.performance.minimumStepCount !== null && this.form.performance.minimumStepCount !== undefined ? Number(this.form.performance.minimumStepCount) : 0
          },
          individualCoaching: {
            maxSessionsPerUser: this.form.sessionsPerUser,
            overallSessionQuota: this.form.overallQuota,
            bookingExpiry: this.form.expiryDate || null
          },
          coaches: this.form.coaches.map(coach => ({
            userUuid: coach.uuid,
            calendlyEventTypeLinkWithSlug: coach.calendlyLink,
            isEnabled: coach.enabled
          }))
        };
        (0, _subscriptions.createSubscription)(token, payload).then(response => {
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Subscription created successfully.', 'success');
          this.goEdit(response.data.id);
        }).catch(error => {
          (0, _log.showDebugLog)('createSubscription-api-error', error);
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)('Failed to create subscription. ' + (error.message || ''), 'error');
        });
      }
    },
    goEdit(id) {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({
          path: '/subscriptions/edit/' + id
        });
      });
    },
    goBack() {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.push({
          path: '/subscriptions/index'
        });
      });
    }
  }
};